const localStorageKeys = {
	session: 'session',
	storedEmail: 'storedEmail',
	devDomain: 'devDomain',
	storedLocationId: 'storedLocationId',
}

export default localStorageKeys
